export default "__VITE_ASSET__$3De0KLg__"